import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "../Hedron";

const Bounds = styled(Grid.Bounds)`
  ${({ theme }) => css`
    width: 100%;
    height: 100vh;
    background-color: ${theme.colors.white};
    justify-content: center;
    align-items: center;

    @media (min-width: 600px) {
      align-items: center;
      background-color: ${theme.colors.lightestGrey};
    }

    .content {
      padding: ${theme.spacing.padding.md};
      background: ${theme.colors.white};
      width: 100%;
      margin: 50px 0;

      @media (min-width: 600px) {
        width: auto;
        min-width: 450px;
        border-radius: ${theme.borderRadius};
        box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.4);
      }
    }
  `}
`;

interface BrandSplitViewProps {
  children: React.ReactNode;
  currentUserStatus?: boolean;
}

const BrandSplitView: React.ReactFCWithChildren<BrandSplitViewProps> = props => {
  const { children } = props;

  return (
    <Bounds direction="horizontal">
      <Grid.Box className="content">
        {children}
      </Grid.Box>
    </Bounds>
  );
};

export default BrandSplitView;
